module.exports = __webpack_public_path__ + "img/esg-2.291a6180.png";